import { useTranslation } from 'react-i18next'

import { Render } from '@/components/render-if'
import { SimulacaoParcelasAgrupadas } from '@/shared/simulacao-agrupador-parcelas'

import { SectionItem, SectionItemValue } from './index'

export type SectionItemParcelaProps<T extends { valor: number }> = {
  label: string
  parcela?: T
  colSpan?: 4 | 8 | 12
  withRightBorder?: boolean
  className?: string
  formatToCurrency: (value: number) => string
}

export function SectionItemParcela<T extends { valor: number }>({
  label,
  parcela,
  colSpan,
  withRightBorder,
  className,
  formatToCurrency,
}: Readonly<SectionItemParcelaProps<T>>) {
  return (
    <SectionItem
      data-testid="section-item-parcela"
      label={label}
      colSpan={colSpan}
      withRightBorder={withRightBorder}
      className={className}
    >
      <Render.If condition={parcela} fallback={<SectionItemValue>{formatToCurrency(0)}</SectionItemValue>}>
        {(p) => <SectionItemValue>{formatToCurrency(p.valor)}</SectionItemValue>}
      </Render.If>
    </SectionItem>
  )
}

export type SectionItemGrupoParcelaProps<T extends Array<{ valor: number; quantidade: number }>> = {
  label: string
  parcelas?: T
  colSpan?: 4 | 8 | 12
  withRightBorder?: boolean
  className?: string
  formatToCurrency: (value: number) => string
}

export function SectionItemGrupoParcela<T extends Array<{ valor: number; quantidade: number }>>({
  label,
  parcelas,
  colSpan,
  withRightBorder,
  className,
  formatToCurrency,
}: Readonly<SectionItemGrupoParcelaProps<T>>) {
  const { t } = useTranslation('simulacao')

  return (
    <SectionItem
      data-testid="section-item-grupo-parcela"
      label={label}
      colSpan={colSpan}
      withRightBorder={withRightBorder}
      className={className}
    >
      <Render.If
        condition={parcelas}
        fallback={
          <SectionItemValue uppercase>{t('pages.simulacao.valores_simulados.nenhuma_parcela')}</SectionItemValue>
        }
      >
        {(p) => (
          <SimulacaoParcelasAgrupadas
            parcelas={p}
            isGrupoSaldo={false}
            className="font-poppins text-base font-normal"
            formatCurrency={formatToCurrency}
          />
        )}
      </Render.If>
    </SectionItem>
  )
}
